(function ($, window, undefined) {


    /*
	 * Animação do file input Anexar foto
	 */
    (function () {
        'use strict';

        if ($('.custom-file-avatar').length > 0) {

            var $divAvatar = $('.custom-file-avatar');

            var $avatarThumb = $divAvatar.find('.avatar-thumb'),
				$avatarHidden = $divAvatar.parents().find('.avatar'),
				$avatarFile = $divAvatar.parents().find('.file-avatar');

            /*
			 * Se o valor do input hidden estiver preenchido, coloca a imagem cadastrada
			 */
            if ($avatarHidden.val() !== '') {

                $avatarThumb
					.css({
					    'background-image': 'url(' + $avatarHidden.data('caminho') + '',
					    'opacity': 1
					});

                $avatarFile.removeAttr('data-required');
            }

            $(document).on('change', '.file-avatar', function () {

                

                if (typeof FileReader !== 'undefined') {


                    var sizeInMB = ($(this)[0].files[0].size / (1024 * 1024)).toFixed(2);
                    //console.log(sizeInMB);
                    
                    if(sizeInMB < 5){

                            if ($(this)[0].files[0] !== 'undefined' && $(this).val() !== '') {

                                var file = $(this)[0].files[0],
							        readImg = new FileReader();

                                if ($(this).val() !== '') {
                                    readImg.readAsDataURL(file);
                                    readImg.onload = function (event) {
                                        $avatarThumb.css({
                                            'background-image': 'url(' + event.target.result + ')',
                                            'opacity': 1
                                        });
                                    };
                                } else {
                                    $avatarThumb.css({
                                        'background-image': 'none',
                                        'opacity': 0
                                    });
                                }
                            }


                    } else {
                        $avatarFile.val('');
                        $avatarHidden.val('');
                        alert("Limite de upload 5MB");
                    }
                }

            });
        }

    }());

    /*
	 * Tratamento para Anexar curriculo
	 */
    (function () {
        'use strict';

        var $hiddenFile = $('.custom-file-cv').parents().find('.curriculo'),
			$curriculo = $('.custom-file-cv').parents().find('.file-curriculo');

        if ($hiddenFile.val() !== '') {
            $curriculo.removeAttr('data-required');
        }

        $(document).on('change', '.file-curriculo', function () {


            var sizeInMB = ($(this)[0].files[0].size / (1024 * 1024)).toFixed(2);
            var nomeFile = $(this)[0].files[0].name
            //console.log(sizeInMB);
            //console.log(nomeFile);

            if(sizeInMB < 5){
                if ($(this).val() !== '') {

                    $('.custom-file-cv').addClass('active');

                    setTimeout(function () {
                        $('.custom-file-cv').removeClass('active');
                        setTimeout(function () {
                            $('.current-file').text(nomeFile);
                        }, 1000);
                    }, 1700);

                } else {
                    $('.custom-file-cv').removeClass('active');
                    $('.current-file').text('');
                }

            } else {
                $hiddenFile.val('');
                $curriculo.val('');
                alert("Limite de upload 5MB");
            }

        });

    }());

    /*
	 * Máscaras dos inputs
	 */
    (function () {
        'use strict';

        $('.input-cpf').mask('000.000.000-00', { reverse: true });
        $('.input-rg').mask('99.999.999-9');
        $('.input-cep').mask('00000-000');
        $('.input-data').mask('00/00/0000');
        $('.input-moeda').mask('000.000,00', { reverse: true });
        $('.input-numero').mask('0#');
        $('#FuncionarioQiID').mask('000');

        var formatarTelefone = function (val) {
            return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
        },
		telefoneOptions = {
		    onKeyPress: function (val, e, field, options) {
		        field.mask(formatarTelefone.apply({}, arguments), options);
		    }
		};

        $('.input-telefone').mask(formatarTelefone, telefoneOptions);
    }());

    /*
	 * Popular Cidades e Estados
	 */
    (function () {
        'use strict';

        if (($('#Uf').length > 0) || ($('#Cidade').length > 0)) {
            new App.CidadesEstados({
                estado: $('#Uf'),
                cidade: $('#Cidade'),
                siglaEstado: true
            });
        }

    }());

    /*
	 * Datepicker do calendários
	 */
    (function () {
        'use strict';

        $('.input-datepicker').datepicker({
            format: 'dd/mm/yyyy',
            keyboardNavigation: true,
            autoclose: true
        }).on({
            'changeDate': function (e) {
                if (e.viewMode == 'days') {
                    $(this).datepicker('hide');
                }
            },
            keydown: function (e) {
                if (e.keyCode === 9) {
                    $(this).datepicker('hide');
                } else if (e.keyCode === 27) {
                    $(this).datepicker('hide');
                }
            }
        });

        $('.input-data').each(function () {
            if ($(this).val() == '01/01/0001') {
                $(this).val('');
            }
        });

        setTimeout(function () {
            $('.input-datepicker').datepicker('update', new Date());
        });

    }());

    /*
	 * Contador de caracteres
	 */
    (function () {
        'use strict';

        $(document).on('keyup', '.input-counter', function () {
            var limite = $(this).attr('maxlength'),
				tamanhoAtual = $(this).val().length,
				$contador = $(this).parents('label').find('.tag-counter');

            $contador.text(limite - tamanhoAtual);
        });
    }());

    /*
	 * Tratamento para exibir/esconder campo de Disponibilidade
	 */
    (function () {
        'use strict';

        var $selectDisponibilidade = $('select[name=DisponibilidadeInicio]'),
			$dataDisponibilidade = $('.inicio-imediato');

        if ($selectDisponibilidade.val() == 'false') {
            $dataDisponibilidade.fadeIn(300);
        } else {
            $dataDisponibilidade.fadeOut(300);
        }

    }());

    /*
	 * Comportamento para verificar se o usuário possui experiencia
	 * Caso possua, irá mostrar o container para preencher experiencias
	 */
    (function () {
        'use strict';

        var $radioButtonExperiencia = $('input[name=PossuiExperiencia]'),
			$menuExperiencia = $('.form-tabs').find('.experiencia'),
			$formExperiencia = $('#experiencia'),
			$paginaExperiencia = $('.form-steps-nav').find('.form-step-experiencia');

        $radioButtonExperiencia.on('change', function () {
            var value = $(this).val();

            if (value == 'True') {
                $menuExperiencia.addClass('visible');
                $formExperiencia.addClass('visible');
                $paginaExperiencia.addClass('visible');
            } else {
                $menuExperiencia.removeClass('visible');
                $formExperiencia.removeClass('visible');
                $paginaExperiencia.removeClass('visible');
            }
        });

        var value = $('input[name=PossuiExperiencia]:checked').val();

        if (value == 'True') {
            $menuExperiencia.addClass('visible');
            $formExperiencia.addClass('visible');
            $paginaExperiencia.addClass('visible');
        } else {
            $menuExperiencia.removeClass('visible');
            $formExperiencia.removeClass('visible');
            $paginaExperiencia.removeClass('visible');
        }

    }());


    /*
	 * Ajax buscar CEP e popular logradouro
	 */
    (function () {
        'use strict';

        $(document).on('keyup', '.input-cep', function (event) {

            if (event) {
                event.preventDefault();
            }

            var $inputCep = $('.input-cep'),
				cep = $(this).val(),
				tamanho = $(this).val().length;

            if (tamanho > 8) {

                $.ajax({
                    url: '//apps.widenet.com.br/busca-cep/api/cep.json?code=' + cep,
                    dataType: 'json',
                    beforeSend: function () {
                        $inputCep.parents('label').find('.spinner').addClass('show');
                    }
                }).done(function (response) {
                    // CEP encontrado, popula os campos automaticamente
                    if (response.status > 0) {
                        $inputCep.parents('label').find('.spinner').removeClass('show');
                        $('#Uf').val(response.state).trigger('change');
                        $('#Cidade').val(response.city).trigger('change');
                        $('#Bairro').val(response.district).trigger('blur');
                        $('#Endereco').val(response.address).trigger('blur');
                        $('#Numero').focus();
                    } else {
                        // CEP não encontrado
                        $inputCep.parents('label').find('.spinner').removeClass('show');
                        $('#Bairro').val('').trigger('focus');
                        $('#Endereco').val('').trigger('blur');
                    }
                });
            } else {
                return false;
            }

        });
    }());

    /*
	 * Cadastro de Currículo - Validação do formulário
	 */
    (function () {
        'use strict';

        if ($.fn.validate) {
            $('.form-trabalhe-conosco').validate({
                events: 'blur change keyup',
                filter: '.form-container.active *',
                eachInvalid: function () {
                    if (!$(this).hasClass('invalid')) {

                        if ($(this).is('input[type="text"]')) {

                            $(this).addClass('invalid');
                            var inputText = $(this).parents('label').find('.texto-label').text();

                            if ($(this).attr('name') == 'PerfilLinkedin' ||
								$(this).attr('name') == 'PerfilFacebook' ||
								$(this).attr('name') == 'Portfolio') {
                                $(this).parents('label').append('<span class="erro msg-validacao">URL é inválida</span>');
                            } else {
                                $(this).parents('label').append('<span class="erro msg-validacao">' + inputText + ' é obrigatório.</span>');
                            }
                        }

                        else if ($(this).is('input[type="file"]')) {
                            $(this).parents('label').find('.custom-file').addClass('invalid');
                            var inputFile = $(this).parents('label').find('.texto-label').text();
                            $(this).parents('label').find('.erro').remove();
                            $(this).parents('label').append('<span class="erro msg-validacao">' + inputFile + ' é obrigatório.</span>');
                        }

                        else if ($(this).is('input[type="radio"]')) {
                            $(this).parents('label').parent().parent().find('.custom-radio').addClass('invalid');
                            var inputRadio = $(this).parents('label').parent().find('.texto-label').text();
                            $(this).parents('label').parent().find('.erro').remove();
                            $(this).parents('label').parent().append('<span class="erro msg-validacao">' + inputRadio + ' é obrigatório.</span>');
                        }

                        else if ($(this).is('select')) {
                            //console.log($(this));
                            $(this).parents('label').find('.custom-select').addClass('invalid');
                            var selectText = $(this).parents('label').find('.texto-label').text();
                            $(this).parents('label').find('.erro').remove();
                            $(this).parents('label').append('<span class="erro msg-validacao">' + selectText + ' é obrigatório.</span>');
                        }

                        else if ($(this).is('textarea')) {
                            $(this).addClass('invalid');
                            var textareaText = $(this).parents('label').find('.texto-label').text();
                            $(this).parents('label').append('<span class="erro msg-validacao">' + textareaText + ' é obrigatório.</span>');
                        }
                    }
                },
                eachValid: function () {

                    if ($(this).is('input[type="text"]')) {
                        $(this).removeClass('invalid');
                        $(this).parents('label').find('.erro').remove();
                    }

                    else if ($(this).is('input[type="file"]')) {
                        $(this).parents('label').find('.custom-file').removeClass('invalid');
                        $(this).parents('label').find('.erro').remove();

                    }

                    else if ($(this).is('input[type="radio"]')) {
                        $(this).parents('label').parent().parent().find('.custom-radio').removeClass('invalid');
                        $(this).parents('label').parent().find('.erro').remove();
                    }

                    else if ($(this).is('select')) {
                        $(this).parents('label').find('.custom-select').removeClass('invalid');
                        $(this).parents('label').find('.erro').remove();
                    }

                    else if ($(this).is('textarea')) {
                        $(this).removeClass('invalid');
                        $(this).parents('label').find('.erro').remove();

                    }
                }
            });
        }
    }());

    /*
	 * Cadastro de Currículo - Navegação das etapas
	 */
    (function () {
        'use strict';

        // Navegação para as próximas etapas do formulário
        var formstep = new App.FormSteps('.form-trabalhe-conosco');

        formstep.init();
        formstep.showPercentageOfSteps();

        var index = $('.form-step-item.active').index();
        formstep.getCurrentHeight(index);

        //  Navegação pelas abas do header
        $('.form-tabs a').on('click', function (event) {
            event.preventDefault();

            $('.form-trabalhe-conosco').validate('trigger');

            if ($('.form-trabalhe-conosco').validate('isvalid')) {
                var index = $('.form-tabs li').not(':hidden').index(this.parentElement);
                formstep.navAction(index);
                formstep.getCurrentHeight(index);
                App.isSendButton('.form-steps .next-step');
                

                var heightForm = $('#formTrabalheConosco fieldset.active').outerHeight();
                $('.box-trabalhe-conosco .carousel').animate({
                    height: heightForm + 50
                });

            }
                
        });

        // Navegação pela paginação do footer
        $('.form-step-item').on('click', function (event) {
            event.preventDefault();

            $('.form-trabalhe-conosco').validate('trigger');

            var indexGo = $(this).index();
            var indexNow = $('.form-step-item.active').index();

            if (indexGo < indexNow) {

                var index = $('.form-step-item').not(':hidden').index(this);
                formstep.navAction(index);
                formstep.getCurrentHeight(index);
                App.isSendButton('.form-steps .next-step');


                var heightForm = $('#formTrabalheConosco fieldset.active').outerHeight();
                $('.box-trabalhe-conosco .carousel').animate({
                    height: heightForm + 50
                });

            }else{

                if ($('.form-trabalhe-conosco').validate('isvalid')) {
                    var index = $('.form-step-item').not(':hidden').index(this);
                    formstep.navAction(index);
                    formstep.getCurrentHeight(index);
                    App.isSendButton('.form-steps .next-step');
                

                    var heightForm = $('#formTrabalheConosco fieldset.active').outerHeight();
                    $('.box-trabalhe-conosco .carousel').animate({
                        height: heightForm + 50
                    });
                }

            }
                

        });

        App.isSendButton = function (element) {

            var $submitBtn = $(element),
				$currentIndex = $('.form-container.active').index(),
				$lastIndex = $('.form-container:last-child').index();

            if ($currentIndex == ($lastIndex)) {
                $submitBtn.text('Enviar');
                setTimeout(function () {
                    $submitBtn.addClass('send-button');

                });
            } else {
                $submitBtn.text('Próximo');
                $submitBtn.removeClass('send-button');
            }
        };

        // Navegação do botão Próximo
        $('.form-steps .next-step').on('click', function (event) {
            event.preventDefault();

            $('.form-trabalhe-conosco').validate('trigger');

            if ($('.form-trabalhe-conosco').validate('isvalid')) {

                var $currentIndex = $('.form-container.active').index(),
					$lastIndex = $('.form-container:last-child').index();

                //formstep.showPercentageOfSteps();

                if ($currentIndex != ($lastIndex)) {
                    formstep.goto($currentIndex + 1);
                    formstep.getCurrentHeight($currentIndex + 1);
                }

             

                    App.isSendButton(this);

             

                
                var heightForm = $('#formTrabalheConosco fieldset.active').outerHeight();
                $('.box-trabalhe-conosco .carousel').animate({
                    height: heightForm + 50
                });

            }
        });

        // Navegação do botão Voltar
        $(document).on('click', '.prev-step', function (event) {
            event.preventDefault();

           // $('.form-trabalhe-conosco').validate('trigger');
           // if ($('.form-trabalhe-conosco').validate('isvalid')) {
                
                
                var $index = $('.form-container.active').index();
                if($('#formTrabalheConosco > :visible.active').is(':last-child')){
                    formstep.goto($('#formTrabalheConosco > :visible').length-2);
                }else{
                    formstep.goto($index - 1);
                }
                
                formstep.getCurrentHeight($index - 1);
                App.isSendButton('.form-steps .next-step');

                var heightForm = $('#formTrabalheConosco fieldset.active').outerHeight();
                $('.box-trabalhe-conosco .carousel').animate({
                    height: heightForm + 50
                });

           // }

        });

        // Select de Indicação
        var $selectIndicacao = $('select[name=ComoFicouSabendo]'),
			$dataIndicacao = $('.codigo-colaborador');

        $selectIndicacao.on('change', function () {
            
            if ($(this).val() == 4) {
                $dataIndicacao.fadeIn(300);
                $dataIndicacao.find('input[name="FuncionarioQiID"]').data('required', '');
                //	formstep.getCurrentHeight(index);
            } else {
                $dataIndicacao.fadeOut(300);
                $dataIndicacao.find('input[name="FuncionarioQiID"]').removeData('required');
                //	formstep.getCurrentHeight(index);
            }
        });



        var $inputIndicacao = $('#FuncionarioQiID');

        $inputIndicacao.on('keyup', function () {


            var codUsuarioQi = $(this).val();

            if(codUsuarioQi){

            $inputIndicacao.parents('label').find('.spinner').addClass('show');

                $.post(
                   '/Carreira/RetornarQi',
                   {
                       codUsuario: codUsuarioQi
                   },
                   function (retorno) {
                       $inputIndicacao.parents('label').find('.spinner').removeClass('show');
                       var msg = retorno.Result;
                       if (msg.length < 120) {
                           $('.mensagemQI').html(msg);
                           $('.mensagemQI').addClass('valido');
                           return true;
                       } else {
                           $('.mensagemQI').html('Código de indicação inválido');
                           $('.mensagemQI').removeClass('valido');
                            return false;
                       }
                   }
                );

            }

        });


        // Select de disponibilidade
        var $selectDisponibilidade = $('select[name=DisponibilidadeInicio]'),
			$dataDisponibilidade = $('.inicio-imediato');

        $selectDisponibilidade.on('change', function () {

            if ($(this).val() == 'false') {
                $dataDisponibilidade.fadeIn(300);
                //	formstep.getCurrentHeight(index);
            } else {
                $dataDisponibilidade.fadeOut(300);
                //	formstep.getCurrentHeight(index);
            }
        });

    }());

    /*
	 * Cadastro de Currículo - Envio do formulário para WebApi
	 */
    (function () {
        'use strict';

        $(document).on('click', '.form-steps .send-button', function (event) {

            if (event) {
                event.preventDefault();
            }

            var $form = $('.form-trabalhe-conosco');
            

            if ($form.validate('isvalid')) {

                var fd = new FormData($form.get(0));

                //console.log(fd);
                //console.log($form.serialize());

                $.ajax({
                    url: $form.attr('action'),
                    type: $form.attr('method'),
                    dataType: 'json',
                    data: fd,
                    processData: false,
                    contentType: false,
                    beforeSend: function () {
                        $('<span/>', {
                            'class': 'spinner-loading'
                        }).appendTo('.send-button');
                    },
                    success: function (response) {

                        $('.spinner-loading').fadeOut(300, function () {
                            $(this).remove();
                        });

                        var $popup = $('#popupCadastro');
                        var $popupBody = $popup.find('.modal-body');
                        var $popupFooter = $popup.find('.modal-footer');

                        // Se o resultado for true, monta o modal com sucesso.
                        if (response.status) {

                            $popupBody.empty();
                            $popupFooter.empty();

                            $('<div/>', {
                                'class': 'icone-sucesso modal-icon'
                            }).appendTo($popupBody);

                            $('<p/>', {
                                'class': 'modal-title',
                                'text': 'Cadastro realizado.'
                            }).appendTo($popupBody);

                            $('<p/>', {
                                'text': 'Enviamos ao seu email um link de confirmação.'
                            }).appendTo($popupBody);

                            $('<p/>', {
                                'html': 'O recebimento poderá levar alguns minutos.'
                            }).appendTo($popupFooter);

                            $popup.modal('show');

                            $popup.on('hidden.bs.modal', function (e) {
                                setTimeout(function () {
                                    document.location.href = '/Carreira/';
                                }, 500);
                            });

                        } else {
                            //console.log(response);
                            //console.log(response.status);

                            // Se for false, monta o modal com erro.
                            $popupBody.empty();
                            $popupFooter.empty();

                            $('<div/>', {
                                'class': 'icone-erro modal-icon'
                            }).appendTo($popupBody);

                            $('<p/>', {
                                'class': 'modal-title',
                                'text': 'Ops! Ocorreu algum erro...'
                            }).appendTo($popupBody);

                            $('<p/>', {
                                'text': 'Por algum motivo, não foi possível completar o cadastro.'
                            }).appendTo($popupBody);

                            $('<p/>', {
                                'text': 'Por favor, tente novamente em alguns instantes.'
                            }).appendTo($popupFooter);

                            $popup.modal('show');
                        }
                    }
                });

            }
        });
    }());

    /*
	 * Ajuste de largura do container das etapas
	 */
    (function () {
        'use strict';

        App.calcWidth = function () {

            var width = document.body.clientWidth,
				boxModel = 40;

            if (width < 480) {

                $('.carousel, .form-steps, .form-trabalhe-conosco .form-container').css({
                    'width': width - boxModel
                });
            }

        };

        App.calcWidth();

        $(window).on('resize', App.calcWidth());

    }());


    var heightForm = $('#formTrabalheConosco fieldset.active').outerHeight();
    $('.box-trabalhe-conosco .carousel').animate({
        height: heightForm + 50
    });

    if ($('select[name=ComoFicouSabendo]').val() == 4) {
        $('.codigo-colaborador').fadeIn(300);
        $('.codigo-colaborador').find('input[name="FuncionarioQiID"]').data('required', '');
    }

    if ($('select[name=ComoFicouSabendo]').val() == 4) {
        var codUsuarioQi = $('.codigo-colaborador').find('input[name="FuncionarioQiID"]').val();
        $('input[name="FuncionarioQiID"]').parents('label').find('.spinner').addClass('show');
    $.post(
            '/Carreira/RetornarQi',
            {
                codUsuario: codUsuarioQi
            },
            function (retorno) {
                var msg = retorno.Result;
                $('input[name="FuncionarioQiID"]').parents('label').find('.spinner').removeClass('show');
                if (msg.length < 120) {
                    
                    $('.mensagemQI').html(msg);
                    $('.mensagemQI').addClass('valido');
                    return true;
                } else {
                    $('.mensagemQI').html('Código de indicação inválido');
                    $('.mensagemQI').removeClass('valido');
                    return false;
                }
                
                
            }
     );
    }


})(jQuery);